module.exports = __webpack_public_path__ + "assets/img/worldfirst-logo.5a14c12c.svg";